import React from 'react';
import Accordion from '../Accordion';

const ComponentsList = ({ 
  components, 
  updateComponent, 
  deleteComponent, 
  duplicateComponent, 
  accordionState,
  onSaveToLibrary,
  layoutId,

  // fixed/updated by ChatGPT on 2026-01-25 17:05:00 – pass add handlers down so GridForm can create components per cell
  onAddComponent,
  onAddFormComponent,
  onAddCardComponent,
  onAddFromLibrary
}) => {
  const visibleComponents = (components || []).filter(c => !c?.isNested && !c?.parentComponentId);
  if (visibleComponents.length === 0) {
    return (
      <div style={{
        padding: '24px',
        textAlign: 'center',
        fontSize: '14px',
        color: '#9CA3AF',
        backgroundColor: '#F9FAFB',
        border: '1px dashed #D1D5DB',
        borderRadius: '8px'
      }}>
        No components added yet. Select a component above to get started.
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gap: '8px' }}>
      {visibleComponents.map((component) => (
        <Accordion
          key={component.id}
          component={component}
          updateComponent={updateComponent}
          deleteComponent={deleteComponent}
          duplicateComponent={duplicateComponent}
          onSaveToLibrary={onSaveToLibrary}
          isExpanded={accordionState.isExpanded(component.id)}
          onToggle={() => accordionState.toggleAccordion(component.id)}
          setRef={(ref) => accordionState.setAccordionRef(component.id, ref)}
          layoutId={layoutId}
          allComponents={components}

          // fixed/updated by ChatGPT on 2026-01-25 17:05:00 – forward add handlers to Accordion → SpecificForm (GridForm)
          onAddComponent={onAddComponent}
          onAddFormComponent={onAddFormComponent}
          onAddCardComponent={onAddCardComponent}
          onAddFromLibrary={onAddFromLibrary}
        />
      ))}
    </div>
  );
};

export default ComponentsList;
